import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import BoonForm from './BoonForm';
import { showBoonApi, updateBoonApi, clearEditedBoon } from './boonSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';

function BoonUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.heroSaga.boon);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(updateBoonApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showBoonApi({ navigate, id }));

        return () => dispatch(clearEditedBoon());
    }, []);

    return (
        <BoonForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default BoonUpdate;
